<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  created() {
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.el-pagination {
  margin: 10px 0 0 0;
  text-align: right;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2f719c;
}
.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.mbx {
  font-size: 16px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px;
  color: #35383c;
}
 /* 解决element-ui的table表格控件表头与内容列不对齐问题 */
  .el-table th.gutter{
    display: table-cell!important;
  }
  .el-form {
      background-color: #ffffff;
      padding: 10px 0px 10px 10px;
  }
  .el-form .el-input_inner{
      background-color: #f8f9fb;
  }
  .el-form .el-input.is-disabled .el-input__inner {
      background-color: #f8f9fb;
      color: #585859;
  }
   /* .el-form .el-input .el-input__inner {
      background-color: #f8f9fb;
      color: #585859;
  } */
  .el-form .el-textarea.is-disabled .el-textarea__inner {
      background-color: #f8f9fb;
      color: #585859;
  }
  /* .el-form .el-textarea .el-textarea__inner{
     background-color: #f8f9fb;
      color: #585859;
  } */
</style>
